export default "__VITE_ASSET__B1whOR89__"